import './register-countries-locale'
import { PhoneNumberUtil } from 'google-libphonenumber'
import * as i18nIsoCountries from 'i18n-iso-countries'

export const isNumberValid = (
  countryAlpha2OrAlpha3Code: string,
  mobileNumber: string,
): boolean => {
  const phoneUtil = PhoneNumberUtil.getInstance()
  try {
    const countryCode = phoneUtil.getCountryCodeForRegion(
      (countryAlpha2OrAlpha3Code.trim().length === 3
        ? (i18nIsoCountries.alpha3ToAlpha2(countryAlpha2OrAlpha3Code) ?? '')
        : countryAlpha2OrAlpha3Code) ?? '',
    )

    return phoneUtil.isPossibleNumberForType(
      phoneUtil.parse(`+${countryCode}${mobileNumber}`),
      1,
    )
  } catch {
    return false
  }
}

export const isCountryCodeValid = (
  alpha2orAlpha3orNumericCode: string | number,
): boolean => {
  return i18nIsoCountries.isValid(alpha2orAlpha3orNumericCode)
}
